import { Type, type Static } from '@sinclair/typebox';

export const CalendarSchema = Type.Object({
  object: Type.Literal('Calendar'),
  id: Type.String({ description: 'The ID of the calendar.' }),
  name: Type.String({ description: 'Name of the calendar.' }),
  description: Type.Optional(Type.String({ description: 'Description of the calendar.' })),
  is_read_only: Type.Boolean({ description: 'Indicates if the calendar is read-only or not.' }),
  is_owned_by_user: Type.Boolean({ description: 'Indicates if the user owns this calendar.' }),
  is_default: Type.Boolean({ description: 'Indicates if this is the primary calendar of the user.' }),
  background_color: Type.String({ description: 'Background color of the calendar in hexadecimal format.' }),
  text_color: Type.Optional(Type.String({ description: 'Foreground color of the calendar in hexadecimal format.' })),
  timezone: Type.Optional(Type.String({ description: 'Timezone used in this calendar.' })),
  specifics: Type.Optional(Type.Any({ description: 'Object containing provider-specific calendar data.' })),
});

export type Calendar<Specifics = unknown> = Omit<Static<typeof CalendarSchema>, 'specifics'> & {
  specifics?: Specifics;
};
